// @packages
import React from 'react';
import { Navigate, Outlet } from 'react-router-native';

// @scripts
import { useAuth } from '../../core/context/provider';

interface Props {
  redirectPath: string;
  isAllowed?: boolean;
}

const ProtectedRoute = ({
  isAllowed,
  redirectPath
}: Props) => {
  const { user } = useAuth();

  if (!isAllowed || !user?.siteIds?.length) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

ProtectedRoute.defaultProps = {
  isAllowed: true
};

export default ProtectedRoute;
